import { LANG_MAP } from 'src/components/Sportsbook/altenar/model/langMap';

export const getCurrentCulture = (culture, lang) => {
  return LANG_MAP[lang] || culture || LANG_MAP.ENG;
};
